import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import createReturnUrl from './utilities/createReturnUrl';
import { useAuth } from './AuthProvider';
import { useStorageKey } from './hooks';

export default function PrivateRoute() {
  const { isLoggedIn, isManualLogout } = useAuth();
  const isAdminSales = useStorageKey('isAdminSales');
  const isAdminClinicalReviewer = useStorageKey('isAdminClinicalReviewer');
  const location = useLocation();

  if (!isLoggedIn) {
    if (location.pathname === '/sign-in') {
      return <Outlet />;
    }
    const redirectUrl = isManualLogout ? '/sign-in' : createReturnUrl('/sign-in', location);
    return <Navigate to={redirectUrl} />;
  }

  if (isAdminSales && location.pathname !== '/pricing-tool') {
    return <Navigate to="/pricing-tool" />;
  }

  if (isAdminClinicalReviewer && !location.pathname.startsWith('/clinical-reviews')) {
    return <Navigate to="/clinical-reviews" replace />;
  }

  return <Outlet />;
}
